import { and, collection, orderBy, query, where } from 'firebase/firestore';

import { getFirestore } from 'services/Firebase';
import { DocumentRole, isSuperUserSiteRole } from 'types/Roles';

import Client from './Client';
import DocumentFolder from './DocumentFolder';
import DocumentFolderCollection from './DocumentFolderCollection';
import { type FolderSchema } from './DocumentFolderTypes';
import root from './RootStore';

export default class ClientsManager extends DocumentFolder {
    documents = new DocumentFolderCollection(
        collection(getFirestore(), 'clients'),
        Client
    );

    onLoad = async (_data: FolderSchema) => {
        if (!root.user?.authenticated) {
            console.log('ClientsManager.onLoad: User not authenticated.');
            return;
        }

        // These constraints are always applied when listing clients...
        const orderConstraint = orderBy('name', 'asc');
        const filterConstraint = where('archived', '==', false);

        if (isSuperUserSiteRole(root.user.role)) {
            this.documents.query = () =>
                query(
                    this.documents.collectionRef,
                    filterConstraint,
                    orderConstraint
                );
        } else if (root.user.id) {
            this.documents.query = () =>
                query(
                    this.documents.collectionRef,
                    // ...but for non-privileged users, we must also filter only
                    // where the user has a bound role
                    and(
                        filterConstraint,
                        where(`members.${root.user.id}.role`, 'in', [
                            DocumentRole.VIEW,
                            DocumentRole.EDIT,
                        ])
                    ),
                    orderConstraint
                );
        } else {
            // No user id, which would form an invalid field path
            // "members..role". In this case, we can't form a valid query,
            // so return null.
            this.documents.query = () => null;
        }

        await this.documents.load();
    };
}
